import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Supabase credentials from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validate environment variables
if (!supabaseUrl) {
  throw new Error('REACT_APP_SUPABASE_URL is not defined. Please check your .env file.');
}
if (!supabaseAnonKey) {
  throw new Error('REACT_APP_SUPABASE_ANON_KEY is not defined. Please check your .env file.');
}

// Singleton pattern to ensure only one Supabase client instance
let supabaseClientInstance: SupabaseClient | null = null;

export const getSupabaseClient = (): SupabaseClient => {
  if (!supabaseClientInstance) {
    supabaseClientInstance = createClient(supabaseUrl, supabaseAnonKey);
  }
  return supabaseClientInstance;
};

// Export the client for backward compatibility
export const supabaseClient = getSupabaseClient();

// Data types for our Supabase tables
export interface PopulationData {
  location_name: string;
  county: string;
  population: number;
  year: number;
}

export interface HealthInsuranceData {
  location_name: string;
  year: number;
  percent_no_insurance: number;
  margin_of_error: number;
}

export interface PvCostData {
  location_name: string;
  year: number;
  cost_per_watt: number;
  system_size: number;
  sector: string;
}

export interface PvSizeData {
  location_name: string;
  year: number;
  system_size: number;
  sector: string;
  project_count: number;
}

export interface EducationalAttainmentData {
  location_name: string;
  year: number;
  race: string;
  gender: string;
  percent_bachelors_degree?: number;
  bachelors_degree?: number;
  bachelors?: number;
  [key: string]: any; // Allow for other columns
}

export interface VMTData {
  location_name: string;
  year: number;
  mode: string;
  vmt: number;
}
